import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import logo from "../assets/image/donation-recipt.png";
import watermarkImg from "../assets/images/logo.png";
import dayjs from "dayjs";
import EmailIcon from "../assets/images/email-icon.jpg";
import WebIcon from "../assets/images/web-icon.jpg";

Font.register({
  family: "CanelaDeckBold",
  src: require("../assets/font/canela/CanelaDeck-Medium-Trial.woff"),
});
Font.register({
  family: "CanelaDeck",
  src: require("../assets/font/canela/CanelaDeck-Light-Trial.woff"),
});

const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 12, position: "relative" },
  section: { marginBottom: 10, marginLeft: 55, marginTop: 10 },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 10,
    textAlign: "center",
  },
  text: { marginBottom: 5, fontFamily: "CanelaDeckBold", marginTop: 5 },
  imageContainer: {
    alignItems: "center",
    marginVertical: 20,
  },
  image: {
    width: 300,
    height: 100,
    alignSelf: "center",
  },
  watermarkContainer: {
    position: "absolute",
    top: "25%",
    left: "10%",
    zIndex: -1,
    opacity: 0.4,
  },
  watermarkImage: {
    width: 400,
    height: 200,
    transform: "rotate(-35deg)",
  },
  emailRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 4,
  },
  emailIcon: {
    width: 15,
    height: 15,
    marginRight: 5,
  },
});

const DonationReciptPdf = ({ data }) => {
  const [payMethod, setPaymentMethod] = useState("");
  useEffect(() => {
    if (!data?.paymentMethod) {
      setPaymentMethod("");
      return;
    }

    const formatLabel = (key) => {
      return key
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    setPaymentMethod(formatLabel(data.paymentMethod));
  }, [data?.paymentMethod]);

  return (
    <Document>
      <Page size={{ width: 730, height: 1000 }} style={styles.page}>
        <View style={styles.watermarkContainer}>
          <Image src={watermarkImg} style={styles.watermarkImage} />
        </View>

        <View style={styles.imageContainer}>
          <Image src={logo} style={styles.image} />
        </View>

        <View style={[styles.section]}>
          <Text style={styles.text}>
            <Text>Date: </Text>
            {dayjs().format("MM/DD/YYYY")}
          </Text>

          <Text style={styles.text}>
            <Text>Receipt #: </Text>
            {data?.invoiceId || "N/A"}
          </Text>
          <Text style={{ marginTop: 15, fontFamily: "CanelaDeck" }}>
            <Text>Dear </Text>
            {data?.name || "N/A"}
          </Text>
          <Text style={[styles.text, { marginTop: 20 }]}>
            <Text style={{ fontFamily: "CanelaDeck" }}>
              With thankful hearts, we acknowledge your gift of{" "}
            </Text>
            <Text style={{ fontFamily: "CanelaDeckBold" }}>
              {" "}
              ${data?.amount}.00{" "}
            </Text>
          </Text>
          <Text style={[styles.text, { marginTop: 15 }]}>
            <Text style={{ fontFamily: "CanelaDeck" }}>
              Your action invests in the education of today’s young minds—a
              simple act today that inspires tomorrow.
            </Text>
          </Text>
          <Text style={[styles.text, { marginTop: 5 }]}>
            <Text>Donation Date: </Text>
            <Text style={{ fontFamily: "CanelaDeck" }}>
              {dayjs(data?.date).format("MM/DD/YYYY")}
            </Text>
          </Text>
          <Text style={styles.text}>
            <Text>Payment Method: </Text>
            <Text style={{ fontFamily: "CanelaDeck" }}>{payMethod}</Text>
          </Text>
          <Text style={styles.text}>
            <Text>Donation Type: </Text>
            <Text style={{ fontFamily: "CanelaDeck" }}>
              {data?.donationFrequency
                ? data.donationFrequency.charAt(0).toUpperCase() +
                  data.donationFrequency.slice(1)
                : ""}
            </Text>
          </Text>

          <Text style={{ fontFamily: "CanelaDeck", marginTop: 5 }}>
            <Text>
              Please retain this letter for your records, as your generous gift
              is fully tax-deductible.
            </Text>
          </Text>
          <Text style={{ fontFamily: "CanelaDeck", marginTop: 8 }}>
            <Text>
              We’re grateful for your support—please feel free to reach out
              anytime.
            </Text>
          </Text>
          <Text
            style={{ fontFamily: "CanelaDeck", marginTop: 80, fontSize: 11 }}
          >
            <Text>Truly,</Text>
          </Text>
          <Text
            style={{ fontFamily: "CanelaDeck", fontSize: 13, marginTop: 10 }}
          >
            <Text>V’Peters Family Scholarship Team</Text>
          </Text>
          <View style={styles.emailRow}>
            <Image src={EmailIcon} style={styles.emailIcon} />
            <Text style={{ fontFamily: "CanelaDeck", fontSize: 11 }}>
              contact@vpeters.org
            </Text>
          </View>
          <View style={styles.emailRow}>
            <Image src={WebIcon} style={styles.emailIcon} />
            <Text style={{ fontFamily: "CanelaDeck", fontSize: 11 }}>
              www.vpeters.org
            </Text>
          </View>
          <View style={styles.imageContainer}>
            <Text
              style={{
                fontFamily: "CanelaDeck",
                fontSize: 12,
                marginTop: 30,
              }}
            >
              Inspiring tomorrow, today!
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default DonationReciptPdf;
